module.exports = __webpack_public_path__ + "img/track.27671bdf.png";